'use client';

import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './Styles.scss';

interface Testimonial {
  id: string;
  quote: string;
  name: string;
  title: string;
  company: string;
  image: string;
}

type PropType = {
  testimonials: Testimonial[];
  autoPlaySpeed?: number;
};

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 1,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

const ChampCarousel: React.FC<PropType> = ({ testimonials, autoPlaySpeed = 5000 }) => {
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <div className="meet-the-champions-hero">
      <div className="meet-the-champions__hero-content">
        <section className="champ-carousel" aria-label="Testimonial Carousel">
          <Carousel
            responsive={responsive}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={autoPlaySpeed}
            transitionDuration={500}
            keyBoardControl={true}
            showDots={true}
            arrows={false}
            removeArrowOnDeviceType={['desktop', 'tablet', 'mobile']}
            containerClass="champ-carousel-container"
            itemClass="champ-carousel-item"
            dotListClass="champ-carousel-dots"
            pauseOnHover={true}
            shouldResetAutoplay={true}
            rewind={false}
            rewindWithAnimation={false}
            renderDotsOutside={true}
          >
            {testimonials.map((testimonial, index) => (
              <div
                className="champ-carousel__slide"
                key={testimonial.id}
                role="group"
                aria-label={`Slide ${index + 1} of ${testimonials.length}`}
              >
                <div className="meet-the-champions__hero-quote">
                  <div className="meet-the-champions__quote-avatar">
                    <img src={testimonial.image} alt={testimonial.name} />
                  </div>
                  <div className="meet-the-champions__quote-text">
                    <p className="meet-the-champions__quote">{testimonial.quote}</p>
                    <div className="meet-the-champions__quote-author">
                      <p className="meet-the-champions__author-name">{testimonial.name}</p>
                      <p className="meet-the-champions__author-title">{testimonial.title}</p>
                      <p className="meet-the-champions__author-company">{testimonial.company}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </section>
      </div>
    </div>
  );
};

export default ChampCarousel;
